export default "__VITE_ASSET__Zn8x0jja__"